module.exports = __webpack_public_path__ + "2021-05-20T043626520Z/img/shelley-gu.4c1d31d1.png";